// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"5acbf908","16":"351c6857","300":"b3741812","453":"127be8e2","597":"65d7938d","652":"4ba84394","890":"2d24c601","975":"9ec0c08f"}[chunkId] + ".chunk.js";
};